import { QueryClient } from "@tanstack/react-query";
export const queryClient = new QueryClient();
// Expose queryClient for Playwright tests (only when using mocks)
if (typeof window !== 'undefined' && import.meta.env.VITE_USE_MOCK_API === 'true') {
    window.__REACT_QUERY_CLIENT__ = queryClient;
}
